import i18n from '~/i18n';
import { getBytesLength } from '~/utils/textUtil/textUtil';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class SmsForm extends Form {
  constructor(data, options) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          const messages = validator.getMessages('en');
          validator.register('maxBytes', (value) => getBytesLength(value) <= 2000);
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'message',
          rules: 'required|maxBytes',
          placeholder: i18n.t('smsModalPlaceholder', '메시지를 입력해 주세요.'),
          value: '',
        },
      ],
    };
  }
}

export default SmsForm;
